export const ACTIVITIES_AUTOMATION_RELOAD_TIMEOUT = 5000
